import { Component, Input } from '@angular/core';

@Component({
  selector: 'rr-progress',
  standalone: false,
  templateUrl: './progress.component.html',
  styleUrl: './progress.component.scss'
})
export class ProgressComponent {
  @Input() progress: number = 0;
}
